import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-product-units',
  templateUrl: './product-units.component.html',
  styleUrls: ['./product-units.component.css']
})
export class ProductUnitsComponent implements OnInit {
    prodId;

    public itemsListProductUnits: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadProductUnits() {
        if (!!this.prodId) {
            this.itemsListProductUnits = await this.datatask.Post(580, { prod_id: this.prodId });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'productunit':
                this.stateService?.go('productunit', {
                    prod_id: this.prodId,
                    productunit_keyno: '0'
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadProductUnits();
    }

    ngOnInit() {
        this.init();
    }
}
